import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Order} from '../models/order';

export const orderStatusActionTypes = {
  ADD: type('[Status changes] Add'),
  TEST_COMPLETED: type('[Status changes] Test Completed'),
  SYNC_DATA: type('[Status changes] Sync'),
  SYNC_DATA_ERROR: type('[Status changes] Sync error'),
  ADD_SUCCESS: type('[Status changes] Add Success'),
  ADD_FAIL: type('[Status changes] Add Fail'),
  IN_SETUP: type('[Status changes] In Setup'),
  CLOSE: type('[Status changes] Close order')
};

export class OrderStatusAddAction implements Action {
  readonly type = orderStatusActionTypes.ADD;
  constructor(public payload?: {uuid: string, status: string}) {}
}

export class OrderInSetupAction implements Action {
  readonly type = orderStatusActionTypes.IN_SETUP;
  constructor(public payload?: {uuid: string}) { }
}
export class TestCompletedAction implements Action {
  readonly type = orderStatusActionTypes.TEST_COMPLETED;
  constructor(public payload?: {uuid: string}) {}
}
export class SyncDataSFAction implements Action {
  readonly type = orderStatusActionTypes.SYNC_DATA;
  constructor(public payload?: {uuid: string}) {}
}
export class SyncDataSFErrorAction implements Action {
  readonly type = orderStatusActionTypes.SYNC_DATA_ERROR;
  constructor(public payload?: {uuid: string}) {}
}



export class OrderStatusSuccessAction implements Action {
  readonly type = orderStatusActionTypes.ADD_SUCCESS;
  constructor(public payload?: Order) {}
}

export class OrderStatusFailAction implements Action {
  readonly type = orderStatusActionTypes.ADD_FAIL;
  constructor(public payload?: string) {}
}
export class OrderStatusCloseAction implements Action {
  readonly type = orderStatusActionTypes.CLOSE;
  constructor(public payload?: {uuid: string, status: string}) {}
}
